import React from "react";
import { Link } from 'react-scroll';

export default function About() {
  return (
    <div id="about" class="h-screen relative">
      <div class="w-8/12 flex mx-auto">
        <div class="w-7/12 text-primary flex flex-col justify-between">
          <div>
            <div class="mb-4">
              <span class="text-2xl">Hello!</span>
            </div>
            <div class="mb-4">
              <span class="text-xl">I am Susan, planner and designer based in Dallas, Texas</span>
            </div>
            <div class="mb-4">
              <span class="text-xl">In my free time, you can find me planning the next girl's trip, reading for the book club I started, browsing interior design inspo for my new home, or sipping on jasmine green milk tea - light ice and 50% sweet.</span>
            </div>
            <div class="mb-4">
              <span class="text-xl">I started this business because wedding planning has been my dream job since I was a kid. In my corporate job, I'm a planner for tech (and sometimes team events), but I'd much prefer using my creativity in planning something beautiful and help people build their special day.</span>
            </div>
            <div class="mb-4">
              <span class="text-xl">~ Susan</span>
            </div>
          </div>
          <div class="w-full flex justify-center">
          <Link to="services" smooth={true} offset={-75}>
            <button class="inline-flex mx-auto bg-button py-4 px-8 rounded-full">
              <span class="uppercase text-primary text-xs">
                Our Services
              </span>
            </button>
            </Link>
          </div>
        </div>
        <div class="w-5/12 pl-12">
          <img class="max-h-full" src={`${process.env.PUBLIC_URL}/images/susan.png`} alt=""></img>
        </div>
      </div>
    </div>
  );
}
